<div #miniDrawerContainer class="mini-drawer-container bkg-white b-radius-9 border-grey pad-M" style="border-width: 0.5px !important;"
     [class.opened]="opened()">
    <ng-content></ng-content>
</div>
